export default "__VITE_ASSET__b4f641c5__"